import React, { useEffect, useState } from 'react';
import styles from './home.module.scss';
import Layout from '../../layouts/User';
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  Radio,
  Row,
  Spin,
  Typography,
} from 'antd';
import { BASE_URL, DEFAULT_PRODUCT_URL } from '../../config';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate, Link, useParams } from 'react-router-dom';
import {
  CloseOutlined,
  LoadingOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import { convertPrice } from '../../utils/display';
import BannerbarPartner from '../../components/TopNavbar/bannerbarPartner';
import { orderBy } from 'lodash';

const { Text, Paragraph } = Typography;
const { Search } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const PartnerHome: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const currentLocationLatLong = useSelector(
    (state: any) => state.currentLocation
  );
  const [currentPageLocation, setCurrentPageLocation] = useState<any>({
    lat: 0,
    long: 0,
  });
  const [isDateText, setDateText] = useState<any>(true); //for Policy
  const navigate = useNavigate();
  const [dueDate, setdueDate] = useState<any>(); //for Policy
  const [isFetchedShop, setIsFetchedShop] = useState(false);
  const [hasProducts, setHasProducts] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState<number>(1);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [productList, setProductList] = useState<any>([]);
  const [productDetail, setProductDetail] = useState<any>([]);
  const [partnerName, setPartnerName] = useState<any>('');
  const [renderProductList, setRenderProductList] = useState<any>([]);
  const [sellerList, setSellerList] = useState<any>([]);

  const { id } = useParams();

  const limit = 10;

  //#region [Privacy]
  const onPrivacyNotice = () => {
    navigate('/PrivacyNotice');
  };
  const clone = async () => {
    localStorage.setItem('DataFixTime', '');
    setDateText(false);
  };

  const days = () => {
    const date1 = new Date('09/1/2022');
    const date2 = new Date();
    let difference = date1.getTime() - date2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    console.log(TotalDays);

    setdueDate(TotalDays);
  };
  //#endregion

  //#region [get data]
  const getPartnerData = async () => {
    try {
      const { data } = await axios.get(`/pages/publish/${id}`);
      setPartnerName(data.data.title);
      setProductList(data.data.pageProducts);
      setSellerList(data.data.pageSellers);
      const productCodeList = data.data.pageProducts.map(
        (item: any) => item.productId
      );
      const sellerCodeList = data.data.pageSellers.map(
        (item: any) => item.sellerCode
      );
      getProductDetail(productCodeList, sellerCodeList);
    } catch (error) {
      navigate('/404');
    }
  };
  //#endregion

  //#region [Search and filter]
  const searchProduct = async (value: any) => {
    if (value) {
      const searchResult = productDetail.filter((item: any) =>
        item.productName.includes(value)
      );
      setRenderProductList(searchResult);
    } else {
      setRenderProductList(productDetail);
    }
  };

  const changeByProductFilter = async (value: string) => {
    let sortResult;
    if (value === 'lowToHigh') {
      sortResult = orderBy(renderProductList, ['userProducts.price'], 'asc');
    } else if (value === 'highToLow') {
      sortResult = orderBy(renderProductList, ['userProducts.price'], 'desc');
    }
    setRenderProductList(sortResult);
  };
  //#endregion

  //#region [render product]
  const addDefaultImage = async (ev: any) => {
    if (!ev.target.errored) {
      ev.target.errored = true;
      ev.target.src = DEFAULT_PRODUCT_URL;
    }
  };

  const getProductDetail = async (productList: any, sellerList: any) => {
    const body = {
      productList: productList,
      sellerList: sellerList,
    };
    const { data } = await axios.post('/products/onepage/detail', body);
    setProductDetail(data);
    setRenderProductList(data);

    if (data.length < limit) {
      setHasProducts(false);
    }
    setIsFetchedShop(true);

    setSkip(skip + 1);
    setLoading(false);
  };
  //#endregion

  //#region [not using]
  useEffect(() => {
    if (currentLocationLatLong.lat && !isFetchedShop) {
      setCurrentPageLocation(currentLocationLatLong);
    }
  }, [currentLocationLatLong]);

  //#endregion

  useEffect(() => {
    getPartnerData();
  }, []);

  useEffect(() => {
    days();
    if (user._id) {
      setCurrentUser(user);
    }
  }, [user]);

  const ProductList = () => {
    return (
      <>
        <Row>
          <Col span={24}>
            <InfiniteScroll
              dataLength={renderProductList.length}
              next={getPartnerData}
              hasMore={false}
              loader={
                <div
                  className={styles.textCenter}
                  style={{
                    marginTop: '90px',
                    marginBottom: '90px',
                    fontSize: '14px',
                  }}
                >
                  <Spin indicator={antIcon} />
                  &nbsp;&nbsp;กำลังโหลดรายการสินค้า
                </div>
              }
              className={styles.infiniteScrollWrapper}
              style={{ overflow: 'unset' }}
            >
              <Row gutter={10}>
                {renderProductList.map((item: any) => {
                  return (
                    <React.Fragment key={item.userProducts._id}>
                      <Col xs={12} sm={6} lg={4} key={item._id}>
                        <Link
                          to={`/shops/product-detail/?id=${item.userProducts._id}&redirect=${window.location.pathname}`}
                        >
                          <Card
                            hoverable
                            className={styles.productItem}
                            bodyStyle={{
                              padding: '7px 0 0 0',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'baseline',
                            }}
                            cover={
                              <img
                                alt='product'
                                src={
                                  item.files.length
                                    ? item.files[0]
                                    : DEFAULT_PRODUCT_URL
                                }
                                onError={async (e) => {
                                  await addDefaultImage(e);
                                }}
                              />
                            }
                          >
                            <Paragraph
                              ellipsis={{ rows: 3, symbol: '...' }}
                              style={{
                                height: '66px',
                                marginBottom: 0,
                                padding: '0 10px',
                              }}
                            >
                              {item.productName}
                            </Paragraph>
                            <div style={{ height: '20px' }}>&nbsp;</div>
                            <div className={styles.antTextSecondary}>
                              <strong>
                                ฿&nbsp;
                                {convertPrice(item.userProducts.price)}
                                <div style={{ height: '14px' }}>&nbsp;</div>
                              </strong>
                            </div>

                            <div className={styles.productItemFooter}>
                              <Paragraph
                                ellipsis={{ rows: 1, symbol: '...' }}
                                className={styles.shopName}
                              >
                                <span>ขายโดย:</span> {item.shops.name}
                              </Paragraph>
                              <div className={styles.shopDistance}></div>
                            </div>
                          </Card>
                        </Link>
                      </Col>
                    </React.Fragment>
                  );
                })}
              </Row>
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <BannerbarPartner id={id} />
      <Layout showTechnicianBar={false}>
        <div className={styles.header}>
          <Text strong className={`${styles.buttonLink} ${styles.active}`}>
            {partnerName}
          </Text>
        </div>
        <Divider className={styles.divider} />
        <Row>
          <Col xs={12} lg={24}>
            <div className={styles.filterText}>ค้นหาสินค้า</div>
          </Col>

          <Col xs={12} md={0}>
            <Link to='/product-categories'>
              <Button
                className={styles.catText}
                shape='round'
                icon={<UnorderedListOutlined />}
                size='small'
              >
                หมวดหมู่
              </Button>
            </Link>
          </Col>

          <Col xs={24} lg={24}>
            <Search
              className={styles.searchInput}
              placeholder='ค้นหาสินค้าที่คุณต้องการ'
              onSearch={searchProduct}
              enterButton
            />
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={5}></Col>

          <Col xs={24} sm={19}>
            <div
              className={`${styles.filterText} ${styles.recommend} ${styles.option}`}
              style={{ paddingBottom: '10px' }}
            >
              <div>เรียงตาม</div>
              <Radio.Group
                onChange={(e) => changeByProductFilter(e.target.value)}
                defaultValue='lowToHigh'
                buttonStyle='solid'
              >
                <Radio.Button
                  value='lowToHigh'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>ราคาน้อย-มาก</span>
                </Radio.Button>
                <Radio.Button
                  value='highToLow'
                  className={`${styles.recommend} ${styles.radioButton}`}
                >
                  <span className={styles.radioText}>ราคามาก-น้อย</span>
                </Radio.Button>
              </Radio.Group>
            </div>
          </Col>
        </Row>

        {ProductList()}

        {dueDate > 0 ? (
          <>
            {isDateText ? (
              <div
                style={{
                  position: 'fixed',
                  zIndex: 99,
                  bottom: 10,
                  right: 10,
                }}
              >
                <Card style={{ width: 300, backgroundColor: '#bebebe' }}>
                  <Card
                    style={{
                      position: 'fixed',
                      zIndex: 99,
                      bottom: 267,
                      right: 18,
                      height: '21px',
                      width: '21px',
                    }}
                  ></Card>
                  <div
                    style={{
                      position: 'fixed',
                      zIndex: 99,
                      bottom: 265,
                      right: 20,
                    }}
                  >
                    <a onClick={clone}>
                      <CloseOutlined
                        style={{ color: 'black', fontSize: '16px' }}
                      />
                    </a>
                  </div>

                  <div>
                    &nbsp;&nbsp;&nbsp;&nbsp;ท่านสามารถขอยกเลิกความยินยอมในการประมวลผลข้อมูลส่วนบุลคล
                    ที่เว็บไซต์เก็บรวบรวมไว้
                    ก่อนวันที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.2562
                    ใช้บังคับ โดยติดต่อผู้ควบคุมข้อมูลส่วนบุคคลที่ระบุไว้ใน
                    &nbsp;
                    <a onClick={onPrivacyNotice}>นโยบายความเป็นส่วนตัว</a>{' '}
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;สำหรับข้อมูลส่วนบุคคลประเภทบุคคล
                    ประเภทอื่นๆ ที่เอสซีจี(บริษัทปูนซีเมนต์ไทย จำกัด (มหาชน)
                    และบริษัทในกลุ่มเอสซีจีตามงบการเงินรวม) ได้เก็บรวบรวมไว้
                    โปรดติดต่อ data.privacy@scg.com
                  </div>
                </Card>
              </div>
            ) : (
              <div></div>
            )}
          </>
        ) : (
          <div></div>
        )}
      </Layout>
    </>
  );
};
export default PartnerHome;
